import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {

  constructor(private router: Router, private route:ActivatedRoute, private authService: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {


    var role = this.authService.getTokenData().role;
    if(role == "admin"){
      console.log("Admin is logged in");
    }
    else{
      console.log("Admin is not logged in");
      this.router.navigate(['login']);
      return false;
    }
        
      

    if (!this.authService.isUserLoggedIn()) {
      //get current b
      console.log("User is not logged in sending to login page");
      this.router.navigate(['login']);
      return false;
    }

    return true;
  }
}
